module.exports = __webpack_public_path__ + "static/media/FOOTER_02.cc69c14b.webp";